import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_work_orders_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId?: number, projectId?: number, warehouseId?: number, statusIds?: number[], fullTextSearch?: string, createdFrom?: string, createdTo?: string }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, ExpectedDate?: string, LookupCode?: string, Notes?: string, ReferenceNumber?: string, StatusId?: number, WarehouseId?: number, Status?: { DisplayName?: string }, Project?: { LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string } }, Warehouse?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_work_orders_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerId?: number, projectId?: number, warehouseId?: number, statusIds?: number[], fullTextSearch?: string, createdFrom?: string, createdTo?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, ExpectedDate?: string, LookupCode?: string, Notes?: string, ReferenceNumber?: string, StatusId?: number, WarehouseId?: number, Status?: { DisplayName?: string }, Project?: { LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string } }, Warehouse?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_work_orders_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerId?: number, projectId?: number, warehouseId?: number, statusIds?: number[], fullTextSearch?: string, createdFrom?: string, createdTo?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, ExpectedDate?: string, LookupCode?: string, Notes?: string, ReferenceNumber?: string, StatusId?: number, WarehouseId?: number, Status?: { DisplayName?: string }, Project?: { LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string } }, Warehouse?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_work_orders_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerId?: number, projectId?: number, warehouseId?: number, statusIds?: number[], fullTextSearch?: string, createdFrom?: string, createdTo?: string    }) {
      return false;
    }
}
